import { render, staticRenderFns } from "./RepairOptions.vue?vue&type=template&id=2b40ae68&scoped=true"
import script from "./RepairOptions.vue?vue&type=script&lang=js"
export * from "./RepairOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40ae68",
  null
  
)

export default component.exports